(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

document.addEventListener('click', event => {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.site-header details[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

function initializeRugProduct(root) {
  root.querySelectorAll('[data-product-section]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const gallery = section.querySelector('[data-rug-gallery]');
    if (gallery) {
      const track = gallery.querySelector('.rug-gallery-track');
      const slides = [...gallery.querySelectorAll('[data-rug-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-rug-thumb]')];
      let active = 0;
      function fitGallery() {
        if (slides[active]) track.style.height = slides[active].offsetHeight + 'px';
      }
      window.addEventListener('resize', fitGallery);
      gallery.querySelectorAll('img').forEach(image => image.addEventListener('load', fitGallery));
      fitGallery();
      function go(index) {
        active = (index + slides.length) % slides.length;
        fitGallery();
        track.scrollTo({left: slides[active].offsetLeft - slides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
      }
      thumbs.forEach((button, i) => button.addEventListener('click', () => go(i)));
      gallery.querySelector('[data-rug-prev]')?.addEventListener('click', () => go(active - 1));
      gallery.querySelector('[data-rug-next]')?.addEventListener('click', () => go(active + 1));
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        if (index >= 0 && index < slides.length) {
          active = index;
          fitGallery();
          thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
        }
      }, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
    const select = section.querySelector('[data-variant-select]');
    if (select) select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      section.querySelector('[data-variant-price]').textContent = option.dataset.price;
      section.querySelector('[data-variant-status]').textContent = option.dataset.status;
      const button = section.querySelector('[data-add-button]');
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    });
    const dialog = section.querySelector('dialog');
    if (!dialog || !dialog.showModal) return;
    let previousFocus;
    section.querySelectorAll('[data-zoom-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      previousFocus = link;
      dialog.querySelector('img').src = link.href;
      dialog.querySelector('img').alt = link.querySelector('img').alt;
      dialog.showModal();
    }));
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => previousFocus?.focus());
  });
}
initializeRugProduct(document);
document.addEventListener('shopify:section:load', event => initializeRugProduct(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-quote"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-quote-section]').forEach(section => {
  const form = section.querySelector('form[action^="/contact"]');
  if (!form) return;
  const summary = section.querySelector('[data-quote-validation]');
  const fields = [...form.querySelectorAll('.form-grid input, .form-grid select, .form-grid textarea')];
  fields.forEach(field => {
    const message = field.closest('.field')?.querySelector('[data-field-error]');
    field.addEventListener('invalid', () => {
      const disclosure = field.closest('details');
      if (disclosure) disclosure.open = true;
      field.setAttribute('aria-invalid', 'true');
      if (message) { message.textContent = field.validationMessage; message.hidden = false; }
      if (summary) summary.hidden = false;
    });
    const update = () => {
      if (field.validity.valid) {
        field.removeAttribute('aria-invalid');
        if (message) { message.textContent = ''; message.hidden = true; }
      }
      if (summary && fields.every(input => input.validity.valid)) summary.hidden = true;
    };
    field.addEventListener('input', update);
    field.addEventListener('change', update);
  });
  const deadline = form.querySelector('input[name="contact[Requested deadline]"]');
  if (deadline) {
    const now = new Date();
    deadline.min = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  }
  const rug = new URL(window.location.href).searchParams.get('rug');
  const details = form.querySelector('textarea[name="contact[body]"]');
  if (rug && details && !details.value.trim()) details.value = section.dataset.rugPrefill + ' ' + rug.slice(0,180) + '\n\n';
});

  } catch(e) { console.error(e); }
})();
})();
